import { 
  Component, 
  Input
} from '@angular/core';
import { 
  NavController
} from 'ionic-angular';
import moment from 'moment';

// Providers
import { InstructorsService } from '../../../providers/instructors/instructors-service';

// Pages
import { InstructorAddEditPage } from '../../../pages/instructors/instructor-add-edit';

@Component({
  selector: 'dashboard-count',
  templateUrl: 'dashboard-count.component.html'
})

export class DashboardCountComponent
{
  @Input() color: string;
  @Input() label: string;
  @Input() status: string;
  @Input() applicationStatus: string;

  instructors: any = [];
  count: number = 0;

  constructor(
    public inspectionsService: InstructorsService,
    public navCtrl: NavController
  )
  {
    setTimeout(() => {
      if ( this.status === 'Expiring' )
      {
        let thisMonth = moment().format('MMMM');
        this.label = this.label + ' in ' + thisMonth;
      }
      this.getInstructors();    
    }, 500);
  }

  getInstructors()
  {
    this.inspectionsService.getInstructorsByStatus( this.status ).subscribe( data => {
      // Remove any instructors marked as Teaching Outside of Oregon.
      let newData = data.filter(function( d ) {
        return d.teach_outside_oregon !== 'Yes';
      });
      this.instructors = newData;
      this.count = this.instructors.length;
    });
  }

  showInstructorAddEditPage( instructor = null )
  {
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: instructor
    });
  }

  ngOnInit()
  {
    //this.getInstructors();  
  }
}  


// WEBPACK FOOTER //
// ./src/pages/dashboard/components/dashboard-count.component.ts